/**
 * Brand color tokens — mirrored from the iOS and Android design systems.
 * Source of truth: cc-ios/Core/DesignSystem/AppColors.swift,
 *                  cc-android/core-designsystem/.../theme/Color.kt
 */
export const colors = {
  primary: '#8CF425',
  primarySoft: 'rgba(140, 244, 37, 0.10)',
  primaryBorder: 'rgba(140, 244, 37, 0.30)',

  cyan: '#06B6D4',
  cyanAlt: '#1DB7E3',
  cyanLink: '#7DD3FC',
  blue: '#3B82F6',
  purple: '#A855F7',

  success: '#73F16B',
  danger: '#FF6B6B',
  warning: '#F59E0B',

  bg: {
    base: '#121212',
    primary: '#020618',
    secondary: '#0F172B',
    card: '#0F172A',
    surface: '#10182B',
    elevated: '#142036',
  },

  slate: {
    950: '#070D1D',
    900: '#10182B',
    800: '#1E293B',
    700: '#334155',
    600: '#475569',
    500: '#64748B',
    400: '#94A3B8',
    300: '#CBD5E1',
  },

  text: {
    primary: '#FFFFFF',
    body: '#CBD5E1',
    secondary: '#94A3B8',
    muted: '#64748B',
    onPrimary: '#070D1D',
  },

  border: {
    default: '#1E293B',
    subtle: '#10182B',
    strong: '#334155',
    accent: 'rgba(140, 244, 37, 0.30)',
  },

  /** Player app surfaces (cc-ios / cc-android), used by in-portal previews. */
  app: {
    card: '#10180D',
    cardBorder: 'rgba(140, 244, 37, 0.14)',
    textSecondary: '#A1A1AA',
  },

  gradient: {
    title: 'linear-gradient(90deg, #8CF425 0%, #9EF75B 22%, #AFF97E 42%, #C0FB9B 64%, #00B8DB 84%, #00B8DB 100%)',
    background: 'linear-gradient(135deg, #020618 0%, #0F172B 50%, #020618 100%)',
    accent: 'linear-gradient(90deg, #06B6D4 0%, #3B82F6 33%, #A855F7 66%, #8CF425 100%)',
    primaryButton: 'linear-gradient(135deg, #8CF425 0%, #73D820 100%)',
  },
} as const;

export type ColorTokens = typeof colors;
